import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { POLICIES, IMAGES } from "@/lib/content";

export default function Policies() {
  return (
    <div data-testid="policies-page">
      <PageHeader
        overline="Clear expectations"
        title="Policies &"
        italic="good to know."
        subtitle="Because each lesson time is reserved specifically for one family, a few clear policies keep everything fair, safe and smooth."
        image={IMAGES.policiesCollage}
      />

      <section className="py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-6">
          {POLICIES.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.05}>
              <div className="p-8 rounded-2xl bg-white border h-full" style={{ borderColor: "rgba(212,175,55,0.25)" }}>
                <h3 className="font-display text-2xl mb-3" style={{ color: "var(--navy)" }}>{p.title}</h3>
                <p className="font-body font-light leading-relaxed" style={{ color: "var(--muted)" }}>{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
